const calendarIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
  <path d="M4 10H6V12H4V10ZM16 2H15V0H13V2H5V0H3V2H2C0.9 2 0 2.9 0 4V18C0 19.1 0.9 20 2 20H16C17.1 20 18 19.1 18 18V4C18 2.9 17.1 2 16 2ZM16 4V6H2V4H16ZM2 18V8H16V18H2ZM8 14H10V16H8V14ZM12 14H14V16H12V14ZM12 10H14V12H12V10Z" fill="white" />
</svg>
export default calendarIcon;